export default __webpack_public_path__ + "static/media/b-8.c6cfcb11.png";